import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter, mergeMap } from 'rxjs/operators';
import { TextService } from 'src/app/core/service/text.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  readonly home = { icon: 'pi pi-home', url: '/#/main/dashboard' };
  menuItems: MenuItem[] = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private textService: TextService
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        mergeMap(() => {
          const menuItems = this.createBreadcrumbs(this.activatedRoute.root);
          return this.textService.convert(menuItems);
        })
      )
      .subscribe((menuItems) => {
        this.menuItems = menuItems;
        return this.menuItems;
      });
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: MenuItem[] = []
  ): MenuItem[] {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }
    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }
      const routeData = child.snapshot.data;
      const label = routeData[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
      if (label != null) {
        const menuData = {
          label: routeData.apiData ? `${routeData.apiData.breadcrumb}` : label,
          labelId: routeData.labelId,
          routerLink: [url],
        };
        breadcrumbs.push(menuData);
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
    return [];
  }
}
